import { Link } from "react-router-dom";
import Navbar from "../components/Navbar";
import { Heart, ArrowLeft } from "lucide-react";

export default function SponsorCancelled() {
  return (
    <div className="min-h-screen">
      <Navbar />
      <main className="max-w-xl mx-auto px-4 py-16">
        <div className="brand-card p-10 text-center" data-testid="sponsor-cancelled-card">
          <Heart className="mx-auto text-primary mb-4" size={36} />
          <h1 className="text-3xl font-extrabold text-[#3D405B] tracking-tight">No worries — your gift was not taken.</h1>
          <p className="text-[#7A7D96] mt-3 leading-relaxed">Whenever you're ready, you can sponsor a session from the homepage. Every contribution funds a real young person.</p>
          <Link to="/#sponsor" className="mt-7 inline-flex items-center gap-1.5 px-6 py-3 rounded-full bg-primary text-white font-bold shadow-md hover:-translate-y-0.5 transition-all" data-testid="sponsor-cancelled-back-btn">
            <ArrowLeft size={15} /> Back to sponsoring
          </Link>
        </div>
      </main>
    </div>
  );
}
